var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.75;fill:#E6E6E6;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.23,51.92 10.5,55.94 10.5,77.5 81.5,93.5 86.5,88.5 86.5,68.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "10.5,55.94 81.5,72.2 86.5,68.25  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 81.5,
    y1: 72.2,
    x2: 81.5,
    y2: 93.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.53,
    y1: 90.47,
    x2: 84.53,
    y2: 69.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "13.36,24.74 13.36,53.56 84.03,70.2 84.03,37.57 81.5,40.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.23,5.72 10.5,9.74 10.5,24.1 81.5,40.1 86.5,35.1 86.5,22.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "10.5,9.74 81.5,26 86.5,22.04  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 81.5,
    y1: 26,
    x2: 81.5,
    y2: 40.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 13.67,
    y1: 7.33,
    x2: 84.53,
    y2: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.53,
    y1: 37.07,
    x2: 84.53,
    y2: 23.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 33.95,
    y1: 29.38,
    x2: 33.95,
    y2: 58.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 61.46,
    y1: 35.65,
    x2: 61.46,
    y2: 64.89
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRibbon);
export default __webpack_public_path__ + "static/media/IconRibbon.38bed6bb83382a52900546bf7bf0db34.svg";
export { ForwardRef as ReactComponent };